module.exports = __webpack_public_path__ + "static/media/fontello.95a0530f.eot";